import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ProductsPage from './components/Home/ProductPage';
import Recruitment from './components/Home/Recruitment';
import 'aos/dist/aos.css';
import AOS from 'aos'; 
import { Analytics } from '@vercel/analytics/react';

import AdminLoginPage from './pages/AdminLoginPage';
import AdminProductsPage from './pages/AdminProductsPage';
import AdminResetPasswordPage from './pages/AdminResetPasswordPage';
import AdminForgotPasswordPage from './pages/AdminForgotPasswordPage';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<ProductsPage />} />
        <Route path="/recruitment" element={<Recruitment />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/products" element={<AdminProductsPage />} />
        <Route path='/admin/reset-password' element={<AdminResetPasswordPage />} />
        <Route path='/admin/forgot-password' element={<AdminForgotPasswordPage />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;